import { Link } from 'react-router-dom';

import { brokers } from '@/data/brokers';

const costGuides = [
  { label: 'Spread', href: '/forex-spread/' },
  { label: 'Commission', href: '/forex-commission/' },
  { label: 'Swap', href: '/forex-swap/' },
  { label: 'Slippage', href: '/forex-slippage/' },
];

const toolsAndCompare = [
  { label: 'Spread vs Commission', href: '/spread-vs-commission/' },
  { label: 'Costs by Strategy', href: '/forex-trading-costs-by-strategy/' },
  { label: 'Cost Calculator', href: '/calculate-forex-trading-costs/' },
  { label: 'Hidden Costs', href: '/hidden-forex-trading-costs/' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0B1F3A' }}>
      <div className="w-full max-w-main mx-auto px-4 md:px-6 py-11 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">

          {/* Column 1: Site Info */}
          <div>
            <Link to="/" className="flex items-center no-underline" style={{ color: '#EAF2FF' }}>
              <img src="/images/footer-logo.png" alt="FXCostGuide" className="h-[36px] w-auto" />
            </Link>
            <p className="mt-3 text-[14px] leading-relaxed" style={{ color: '#AEBFD3' }}>
              Independent forex cost education built by traders, for traders. We break down every fee — spread, commission, swap, slippage, and hidden charges — with real numbers and zero broker bias.
            </p>
            <Link
              to="/about/"
              className="inline-block mt-4 text-[14px] font-medium no-underline transition-colors hover:opacity-80"
              style={{ color: '#EAF2FF' }}
            >
              About Us &rarr;
            </Link>
          </div>

          {/* Column 2: Cost Guides */}
          <div>
            <h4 className="text-[13px] font-semibold uppercase tracking-[0.08em] mb-4" style={{ color: '#EAF2FF' }}>
              Cost Guides
            </h4>
            <div className="flex flex-col gap-2.5">
              {costGuides.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="text-[14px] no-underline transition-colors hover:opacity-80"
                  style={{ color: '#AEBFD3' }}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 3: Tools & Compare */}
          <div>
            <h4 className="text-[13px] font-semibold uppercase tracking-[0.08em] mb-4" style={{ color: '#EAF2FF' }}>
              Tools & Compare
            </h4>
            <div className="flex flex-col gap-2.5">
              {toolsAndCompare.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="text-[14px] no-underline transition-colors hover:opacity-80"
                  style={{ color: '#AEBFD3' }}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 4: Featured Brokers */}
          <div>
            <h4 className="text-[13px] font-semibold uppercase tracking-[0.08em] mb-4" style={{ color: '#EAF2FF' }}>
              Featured Brokers
            </h4>
            <div className="flex flex-col gap-2.5">
              {brokers.map((broker) => (
                <a
                  key={broker.name}
                  href={broker.href}
                  target="_blank"
                  rel="sponsored nofollow noopener"
                  className="text-[14px] no-underline transition-colors hover:opacity-80"
                  style={{ color: '#AEBFD3' }}
                >
                  {broker.name}
                </a>
              ))}
            </div>
          </div>

        </div>

        {/* Divider */}
        <div className="mt-10 md:mt-12 border-t" style={{ borderColor: 'rgba(255,255,255,0.12)' }}></div>

        {/* Risk Notice */}
        <p className="mt-6 text-[13px] leading-relaxed" style={{ color: '#AEBFD3' }}>
          Risk notice: Forex and CFD trading involves significant risk and may not be suitable for all traders. This website provides educational information only and does not offer investment advice.
        </p>

        {/* Copyright */}
        <p className="mt-3 text-[13px]" style={{ color: '#AEBFD3' }}>
          &copy; 2026 FXCostGuide. All rights reserved.
        </p>
      </div>
    </footer>
  );
}